import zhCNPlaces from './placeNames.zh-CN.json';

export function localizePlace(name, language) {
  if (!name) return '';
  const lang = (language || 'en').toLowerCase();
  if (lang.startsWith('zh')) {
    return zhCNPlaces[name] || name;
  }
  return name;
}

export function localizeLocation(location, language) {
  if (!location) return '';
  const { city, state, country } = location;
  const lang = (language || 'en').toLowerCase();
  const sep = lang.startsWith('zh') ? '，' : ', ';
  const parts = [];
  if (city) parts.push(localizePlace(city, lang));
  if (state) parts.push(localizePlace(state, lang));
  if (country) parts.push(localizePlace(country, lang));
  return parts.join(sep);
}


